import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

export interface IOperacionPermitidaQueryParams {
  rut_usu: number;
  codgo_modulo: number;
  cod_operacion: number;
}

@Injectable({
  providedIn: 'root',
})
export class RolOperacionService {
  constructor(private gqlclient: GraphQLClient) {}

  private verificarExitoOperacion(mensajes): boolean {
    if (mensajes && mensajes.length > 0 && mensajes[0].tipo === 'SUCCESS') return true;
    return false;
  }

  operacionPermitida(inputParams: IOperacionPermitidaQueryParams, callback: (allowed: boolean) => void) {
    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($rut_usu: Decimal, $codgo_modulo: Decimal, $cod_operacion: Decimal) {
            rol_operacion {
              operacionPermitida(rut_usu: $rut_usu, codgo_modulo: $codgo_modulo, cod_operacion: $cod_operacion) {
                mensajes {
                  texto
                  tipo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes } = response.data.rol_operacion.operacionPermitida;
        const allowed = self.verificarExitoOperacion(mensajes);
        callback(allowed);
      }
    );
  }
}
